import { axios, AxiosResponse } from '~/modules'
import { IPregnancy, IGetPatientPregnanciesParams, BirthPregnancyFetchParams, BirthPregnancy } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchPatientPregnancies = async (params: IGetPatientPregnanciesParams): Promise<IPregnancy[]> => {
  const { patientId } = params
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/pregnancies`)
  const { data }: AxiosResponse<IPregnancy[]> = response
  return data
}

export const fetchBirthPregnancy = async (params: BirthPregnancyFetchParams): Promise<BirthPregnancy> => {
  const { pathParam } = params
  const response = await axios.get(`${hstoryAPI}/children/${pathParam.childId}/birth-pregnancy`)
  const { data }: AxiosResponse<BirthPregnancy> = response
  return data
}
